import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

interface GraphDetails {
    allData: (data: any[]) => void;
}

const TrainingChart: React.FC<GraphDetails> = ({ allData }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [trainingData, setTrainingData] = useState<any>([]);

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            setTrainingData(allData || []);
            setIsLoading(false);
        }
        fetchData();
    }, [allData]);

    const formatMonthLabel = (monthStr: string) => {
        const [year, month] = monthStr.split("-");
        const date = new Date(`${year}-${month}-01`);

        return date.toLocaleString("en-IN", {
            month: "long",
            year: "numeric",
        });
    };

    // Extract labels + values
    const labels = allData?.map(item => formatMonthLabel(item.month)) || [];
    const values = allData?.map(item => Number(item.count)) || [];

    // Chart Options
    const optionsBar: any = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false }
        },

        plotOptions: {
            bar: {
                columnWidth: "45%",
                borderRadius: 4,
            }
        },

        xaxis: {
            categories: labels,
            title: {
                text: "Month",
            },
            labels: {
                rotate: -30,
                style: { colors: "#0f2a4e", fontSize: "12px" }
            }
        },

        yaxis: {
            min: 0,
            max: 30,
            tickAmount: 6,
            title: {
                text: "Schedule"
            },
        labels: {
            style: {
                colors: "#0f2a4e"  // 👈 Y-axis numbers
            }
        }
        },

        dataLabels: {
            enabled: false
        },

        colors: ["#1eb0d5"],

        tooltip: {
            y: {
                formatter: (val: number) => `${val}`
            }
        }
    };

    const series = [
        {
            name: "Schedule Count",
            data: values
        }
    ];

    return (
        <div id="bar">
            <ReactApexChart
                options={optionsBar}
                series={series}
                type="bar"
                height={250}
                width="100%"
            />
        </div>
    );
};

export default TrainingChart;
